import { createFilterObj } from "../../../components/filter/filterUtils.js";

export function createExpectedActualCmpFilters(rows) {
  const filters = {
    "AliasFilter": createFilterObj({
      name: "AliasFilter",
      filteredPropertyName: "Alias",
      target: "オーダ",
      targetTranslationKey: "$t(asprova.terms.order)",
    }),
    "OrderSeibanFilter": createFilterObj({
      name: "OrderSeibanFilter",
      filteredPropertyName: "Order_Seiban",
      target: "製番",
    }),
    "OrderItemCodeFilter": createFilterObj({
      name: "OrderItemCodeFilter",
      filteredPropertyName: "Order_ItemCode",
      target: "品目",
    }),
    "OrderItemNameFilter": createFilterObj({
      name: "OrderItemNameFilter",
      filteredPropertyName: "Order_ItemName",
      target: "品名",
    }),
  }
  for (const key in filters) {
    filters[key].items = filters[key].getFilterItems(rows, {[key]: filters[key]})
  }
  return filters
}
